export default "__VITE_ASSET__Af50pf0K__"